import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var MoveFileSvg = function MoveFileSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 2.249h12.98L22 7.309v14.94h-8.5v-1.395h7.115V7.887l-4.21-4.243H5.386V11H4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.065 17.634 8.02 13.249l-1.08 1.086L9.397 17H2v1.5h7.286l-2.345 2.697 1.11 1.053zM14 8.499H9v-1.5h5zM19 13.499h-7v-1.5h7zM19 18.499h-3v-1.5h3z"
  }));
};
export var MoveFile = function MoveFile(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: MoveFileSvg
  }));
};